import request from './request'

const http = {
    //广告列表
    companyAdverts(params) {
        return request({
            method: 'POST',
            url: '/store/pc/company/adverts/list',
            data: params
        })
    },
    //新增广告
    addOrUpdateAdverts(params) {
        return request({
            method: 'POST',
            url: '/store/pc/company/adverts/addOrUpdate',
            data: params
        })
    },
    //查看广告详情
    getAdvertsdetlai(params) {
        return request({
            method: 'GET',
            url: '/store/pc/company/adverts/info',
            params: params
        })
    },
    //广告上下架
    upOrDownAdverts(params) {
        return request({
            method: 'GET',
            url: '/store/pc/company/adverts/upOrDown',
            params: params
        })
    },
    //删除广告
    deleteAdverts(params) {
        return request({
            method: 'GET',
            url: '/store/pc/company/adverts/delete',
            params: params
        })
    },
    //资源配置
    getConfig(params) {
        return request({
            method: 'POST',
            url: '/store/pc/company/sys/static/config/list',
            data: params
        })
    },
    //修改资源配置
    updateConfig(params) {
        return request({
            method: 'POST',
            url: '/store/pc/company/sys/static/config/update',
            data: params
        })
    },
    //投诉列表
    getComplaint(params) {
        return request({
            method: 'POST',
            url: '/store/pc/complaint/list',
            data: params
        })
    },
     //投诉列表（处理和备注）
     replyComplaint(params) {
        return request({
            method: 'POST',
            url: '/store/pc/complaint/replyComplaint',
            data: params
        })
    },

     //线上门店列表
     getstoreList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/online/store/list',
            data: params
        })
    },
     //编辑线上门店
     updatestoreList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/online/store/update',
            data: params
        })
    },
     //线上门店详情
     updateStoreinfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/online/store/info',
            params: params
        })
    },
     //开启关闭线上门店启用状态
     updateOnlineEnable(params) {
        return request({
            method: 'GET',
            url: '/store/pc/online/store/updateOnlineEnable',
            params: params
        })
    },
     //议价申请列表
     expectedList(params) {
        return request({
            method: 'POST',
            url: '/store/pc/assess/record/expected/list',
            data: params
        })
    },
      //Q-导出销售订单管理Excel
      sellExcelout(params) {
        return request({
            method: 'POST',
            url: '/store/pc/product/order/excel',
            data: params,
            responseType: 'blob'
        })
    },
     //Q-导出Excel
     excelSend(params) {
        return request({
            method: 'POST',
            url: '/store/pc/assess/record/expected/excel',
            data: params,
            responseType: 'blob'
        })
    },
     //线上评估信息
     assessmentInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/assess/record/expected/assessment/info',
            params: params
        })
    },
    //分享积分管理-详情
    pontsconfigInfo(params) {
        return request({
            method: 'GET',
            url: '/store/pc/points/config/info',
            params: params
        })
    },
    //分享积分管理-修改
    updatepontsInfo(params) {
        return request({
            method: 'POST',
            url: '/store/pc/points/config/update',
            data: params
        })
    },
     //修改其他配置
     updateallconfig(params) {
        return request({
            method: 'GET',
            url: '/store/pc/reclaim/parameters/update/config',
            params: params
        })
    },
     //管理员列表（子账号，创建人）
     getMasterStaffList(params) {
        return request({
            method: 'GET',
            url: '/store/pc/reclaim/parameters/getMasterStaffList',
            params: params
        })
    },
}
export {
    http
}